import React, { FC, useState } from 'react';
import Section from 'evcharging/containers/layout/Section';
import Container from 'evcharging/components/Container';
import Spacer from 'evcharging/components/Spacer';
import useI18n from 'evcharging/hooks/useI18n';
import Paragraph from 'evcharging/components/Paragraph';
import OfferItem from 'containers/about-us/OfferItem';
import Responsible from 'evcharging/components/Responsible';
import { E5Service } from 'evcharging/services/types';
import {STATIC_ABOUT_US_SERVICES, STATIC_SERVICES} from 'config/e5app';
import { assetUrl } from 'evcharging/services/cmsClient';
import Caption from 'evcharging/components/Caption';

interface WhatWeOfferProps {
  services: E5Service[];
}

const WhatWeOffer: FC<WhatWeOfferProps> = (props) => {
  const { services } = props;
  const { t } = useI18n();
  const list = [
    ...STATIC_ABOUT_US_SERVICES.map((s) => ({
      ...s,
      name: t(s.title),
      bgImage: s.imgSrc,
    })),
  ] as any[]

  const [openName, setOpenName] = useState<string>(list[0].name);
  const onToggle = (name: string) => {
    setOpenName(openName === name ? list[0].name : name);
  }

  return (
    <Section background={'light'}>
      <Container maxWidth={'1020px !important'} overflow={'unset'}>
        <Caption>
          {t('about-us.what-we')}
        </Caption>
        <Spacer value={12} />
        <Paragraph size={'large'} textAlign={'center'} color={'middle'}>
          {t('about-us.at-the')}
        </Paragraph>
        <Spacer value={36} />
        <Responsible fractions={[48.7, 48.7]} space={0}>
          <div style={{position: 'relative'}}>
            {list.map((service, index) => (
              <OfferItem
                key={index}
                service={service}
                open={openName === service.name}
                onToggle={() => onToggle(service.name)}
              />
            ))}
          </div>
          {/*<div>*/}
          {/*  {list.slice(2).map((service, index) => (*/}
          {/*    <OfferItem*/}
          {/*      key={index}*/}
          {/*      service={service}*/}
          {/*      open={openName === service.name}*/}
          {/*      onToggle={() => onToggle(service.name)}*/}
          {/*    />*/}
          {/*  ))}*/}
          {/*</div>*/}
        </Responsible>
      </Container>
    </Section>
  );
};

export default WhatWeOffer;
